/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Generation_Status_Not_ReprocessableInputs */

const es_co2_error_generation_status_not_reprocessable = /** @type {(inputs: Error_Generation_Status_Not_ReprocessableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario no está listo para reprocesarse.`)
};

/**

* @param {Error_Generation_Status_Not_ReprocessableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_generation_status_not_reprocessable = /** @type {((inputs?: Error_Generation_Status_Not_ReprocessableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Generation_Status_Not_ReprocessableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_generation_status_not_reprocessable(inputs)
});